import React, { useState } from "react";
import "../styles/PrintProjectsGrid.scss";

// Dynamically import all images
const importAll = (requireContext) => requireContext.keys().map(requireContext);
const allImages = importAll(
  require.context("../assets/print_projects_images", false, /\.(png|jpe?g|svg)$/)
);

// Dynamically import the PDF cover image
const pdfFiles = [
  {
    src: "/print_project_pdfs/TBM2024EOYNewsletter.pdf", // PDF URL
    coverImage: require("../assets/print_projects_images/2024EOYcoverimage.png"), // Dynamically imported cover image
    prefix: "2024EOY", // Prefix for filtering
  },
];

// Filter out the PDF cover image using `startsWith`
const projectImages = allImages.filter((image) => {
  const fileName = image.split("/").pop(); // Extract file name
  return !pdfFiles.some((pdf) => fileName.startsWith(pdf.prefix));
});

function PrintProjectsGrid() {
  const [selectedImage, setSelectedImage] = useState(null);

  const handleImageClick = (image) => {
    setSelectedImage(image); // Open lightbox with the selected image
  };

  const closeLightbox = () => {
    setSelectedImage(null); // Close the lightbox
  };

  return (
    <div>
      <div className="print-projects-grid">
        {/* Render Images (excluding PDF cover images) */}
        {projectImages.map((image, index) => (
          <div
            key={`image-${index}`}
            className="print-projects-item"
            onClick={() => handleImageClick(image)}
          >
            <img src={image} alt={`Print Project ${index + 1}`} />
          </div>
        ))}

        {/* Render PDF Cover Images with Links */}
        {pdfFiles.map((pdf, index) => (
          <a
            key={`pdf-${index}`}
            href={pdf.src}
            target="_blank"
            rel="noopener noreferrer"
            className="print-projects-item pdf-item"
          >
            <img
              src={pdf.coverImage}
              alt={`PDF Cover ${index + 1}`}
              className="pdf-cover-image"
            />
          </a>
        ))}
      </div>

      {/* Lightbox for Selected Image */}
      {selectedImage && (
        <div className="lightbox" onClick={closeLightbox}>
          <div
            className="lightbox-content"
            onClick={(e) => e.stopPropagation()} // Prevent lightbox closure when clicking inside the content
          >
            <button className="close-btn" onClick={closeLightbox}>
              &times;
            </button>
            <img src={selectedImage} alt="Selected Print Project" />
          </div>
        </div>
      )}
    </div>
  );
}

export default PrintProjectsGrid;
